export default "__VITE_ASSET__ddc5ff71__"